export const organizationNotificationSettingsData = [
	{
		notificationType: 'Email Notification ',
		settings: [
			{id: 0, title: 'Table Sale', description: 'Get notified when a table is sold.', value: 'isTicketAndTableSale'},
			{
				id: 1,
				title: 'Guest Update',
				description: 'Get notified when guest information changes.',
				value: 'isGuestUpdate',
			},
			{
				id: 2,
				title: 'Auction Payment',
				description: 'Get notified when an auction payment is received.',
				value: 'isAuctionPayment',
			},
			{
				id: 3,
				title: 'Buy Now',
				description: 'Get notified when a Buy Now item is purchased.',
				value: 'isBuyNow',
			},
			{
				id: 4,
				title: 'Raffle Tickets Sale',
				description: 'Get notified when raffle tickets are sold.',
				value: 'isRaffleTicketsSale',
			},
		],
	},
];

export const userNotificationSettingsData = [
	{
		notificationType: 'Email Notification ',
		settings: [
			{
				id: 0,
				title: 'Ticket and table Update',
				description: 'Receive an email when there is an update to your table.',
				value: 'isEmailTableAndTicket',
			},
			{
				id: 1,
				title: 'Auction Updates',
				description: 'Get notified when you’re outbid and when the auction is closing.',
				value: 'isEmailAuction',
			},
		],
	},
	{
		notificationType: 'SMS notifications',
		settings: [
			{
				id: 2,
				title: 'Ticket and table Update',
				description: 'Receive a text when there is an update to your table.',
				value: 'isSMSTableAndTicket',
			},
			{
				id: 3,
				title: 'Auction Updates',
				description: 'Get notified when you’re outbid and when the auction is closing.',
				value: 'isSMSAuction',
			},
		],
	},
];

export const adminNotificationSettingsData = [
	{
		notificationType: 'Email Notification ',
		settings: [
			{
				id: 0,
				title: 'Accounts update',
				description: 'Notification upon new accounts created',
				value: 'isAccountUpdate',
			},
			{
				id: 1,
				title: 'Event Created',
				description: 'Notification upon new events created',
				value: 'isEventCreated',
			},
			{
				id: 2,
				title: 'Platform Payment',
				description: 'Summary of platform fees processed',
				value: 'isPlatformPayment',
			},
		],
	},
];

export const organizationNotificationSettingsInitialData = {
	isTicketAndTableSale: true,
	isGuestUpdate: true,
	isAuctionPayment: true,
	isBuyNow: true,
	isRaffleTicketsSale: true,
};

export const userNotificationSettingsInitialData = {
	isEmailTableAndTicket: true,
	isEmailAuction: true,
	isSMSTableAndTicket: true,
	isSMSAuction: true,
};

export const adminNotificationSettingsInitialData = {
	isAccountUpdate: true,
	isEventCreated: true,
	isPlatformPayment: true,
};
